import { useContext } from "react";

import { AddPaymentMethodModalProps } from "../components/molecules";
import { AddPaymentMethodModal } from "../components/molecules/AddPaymentMethodModal";
import { ModalContext } from "../providers";

export const useAddPaymentMethodAlert = ({
  userMemberId,
  onConfirm,
  asMember,
}: Partial<AddPaymentMethodModalProps>) => {
  const { stackModal, popModal } = useContext(ModalContext);
  const showAddPaymentMethodAlert = () => {
    if (!userMemberId) return;

    return stackModal(
      <AddPaymentMethodModal
        userMemberId={userMemberId}
        onConfirm={async (newPaymentMethodId) => {
          onConfirm?.(newPaymentMethodId);
          popModal();
        }}
        asMember={asMember}
      />,
    );
  };
  return showAddPaymentMethodAlert;
};
